import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PatientApi } from '@core/apis/patient/patient.api';
import { ICompletion } from '@core/interfaces/interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CreatePasswordFormComponent } from '../../components/create-password-form/create-password-form.component';

@Component({
  selector: 'app-completion-restore',
  imports: [CreatePasswordFormComponent],
  templateUrl: './completion-restore.component.html',
  styleUrl: './completion-restore.component.scss',
})
@UntilDestroy()
export class CompletionRestoreComponent {
  public success: boolean = false;

  constructor(
    private readonly patientApi: PatientApi,
    private router: Router
  ) {}


  restore(data: ICompletion): void {
    this.patientApi
      .restoreCompletion(data)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.success = true;
        this.router.navigate(['/']);
      });
  }
}
